<template>
  <div class="activationLogin">
    <div class="actLoginContent">
      <h2 class="actTitle">绑定账号</h2>
      <div class="from_content">
        <van-form>
          <van-field
            @input="getphoneValue"
            v-model.trim="phoneNum"
            type="tel"
            clearable
            label="手机号"
            placeholder="请输入手机号"
            maxlength="11"
            @blur="phoneblur"
            :rules="[{ pattern }]"
          />
          <van-field
            class="codeField"
            v-model.trim="verCode"
            center
            label="验证码"
            placeholder="请输入验证码"
            @blur="codeblur"
          >
            <template #button>
              <van-button size="small" type="primary" @click="getverCode" v-if="isCodeFlag"
                >获取验证码</van-button
              >
              <van-button
                size="small"
                type="primary"
                v-if="isCodeFlag ? false : true"
                :class="isCodeFlag ? '' : 'noActive'"
                >重新获取{{ codeCount }}s</van-button
              >
            </template>
          </van-field>
          <div class="login_btn">
            <van-button
              type="primary"
              size="large"
              :disabled="btnState"
              :class="{ btnBg: btnState }"
              @click="onClickNext"
              >下一步</van-button
            >
          </div>
        </van-form>
      </div>
    </div>
  </div>
</template>

<script>
import { queryCode, phoneLogin } from '@/api/login';

export default {
  props: {},
  data() {
    return {
      phoneNum: '', // 手机号
      verCode: '', // 验证码
      codeCount: '60', // 验证码倒计时
      btnState: true,
      pattern: /^1(3|4|5|6|7|8|9)\d{9}$/, // 正则验证手机号
      OS: '',
      isCodeFlag: true, // 验证码按钮状态
      timer: null,
    };
  },

  computed: {},
  created() {
    const OS = this.getOS();
    this.OS = OS;
  },

  mounted() {},

  methods: {
    getOS() {
      // 获取当前操作系统
      let os;
      if (
        navigator.userAgent.indexOf('Android') > -1
        || navigator.userAgent.indexOf('Linux') > -1
      ) {
        os = 'Android';
      } else if (navigator.userAgent.indexOf('iPhone') > -1) {
        os = 'iOS';
      } else if (navigator.userAgent.indexOf('Windows Phone') > -1) {
        os = 'WP';
      } else {
        os = 'Others';
      }
      return os;
    },
    getphoneValue() {
      if (this.pattern.test(this.phoneNum)) {
        this.btnState = false;
      } else {
        this.btnState = true;
      }
    },
    phoneblur() {
      if (this.phoneNum === '' || this.phoneNum === undefined) {
        this.$toast('手机号不为空');
      } else if (!this.pattern.test(this.phoneNum)) {
        this.$toast('手机号格式错误');
      }
    },
    codeblur() {
      if (this.verCode === '' || this.verCode === undefined) {
        this.$toast('验证码不为空');
      }
    },
    // 获取验证码
    async getverCode() {
      if (this.phoneNum === undefined || this.phoneNum === '') {
        this.$toast('手机号不为空');
      } else if (!this.pattern.test(this.phoneNum)) {
        this.$toast('手机号格式错误');
      } else {
        const TIME_COUNT = 60;
        this.codeCount = TIME_COUNT;
        this.isCodeFlag = false;
        const res = await queryCode({
          type: 'login',
          phone: this.phoneNum,
        });
        if (res.code === 0) {
          this.$toast('验证码已发送');
          this.timer = setInterval(() => {
            if (this.codeCount > 0 && this.codeCount <= TIME_COUNT) {
              // eslint-disable-next-line no-plusplus
              this.codeCount--;
            } else {
              this.isCodeFlag = true;
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        } else {
          this.$toast(res.msg);
        }
      }
    },
    // 登录
    async onClickNext() {
      if (this.verCode === undefined || this.verCode === '') {
        this.$toast('验证码不为空');
      } else {
        const params = {
          phone: this.phoneNum,
          smsCode: this.verCode,
          loginType: 1,
          clientType: 3,
          os: this.OS,
          loginTerminal: 5,
          terminal: 5,
          sourceType: 1,
          registerPlatform:this.$root.miniprogram?5:2,
        };
        const res = await phoneLogin(params);
        if (res.code === 0) {
          window.localStorage.setItem('accessToken', res.data.token);
          // 登录成功 跳到激活页
          this.$router.push({
            path: '/acvitateCourse',
          });
        } else {
          this.$toast(res.msg);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.activationLogin {
  width: 100%;
  min-height: 100vh;
  background: #fff;
  .actLoginContent {
    width: 83%;
    margin: 0 auto;
    .actTitle {
      margin-top: 48px;
      color: #333;
      font-weight: 600;
      font-size: 40px;
      line-height: 56px;
    }
    .from_content {
      margin-top: 64px;
      ::v-deep .van-form {
        .van-cell {
          padding-right: 0;
          padding-left: 0;
          &::after {
            border-bottom: none;
          }
          .van-field__label {
            width: 4.6em;
            margin-right: 0;
            line-height: 28px;
            span {
              color: #333;
              font-weight: 400;
              font-size: 14px;
              line-height: 20px;
            }
          }
          .van-field__body {
            padding-bottom: 8px;
            border-bottom: 1px solid #eee;
            .van-field__control {
              height: 28px;
              font-size: 14px;
              line-height: 28px;
            }
          }
        }
        .van-cell--center {
          margin-top: 10px;
        }
        .van-field__button {
          box-sizing: border-box;
          .van-button--primary {
            width: 100%;
            height: 28px;
            color: #ff6c02;
            font-weight: 400;
            font-size: 12px;
            background: #fff;
            border: 1px solid #ff6c02;
            border-radius: 4px;
          }
          .noActive {
            color: #a5a5a5;
            border: 1px solid #a5a5a5;
          }
        }
        .codeField {
          .van-field__body {
            margin-top: 8px;
          }
        }
      }
      .login_btn {
        margin-top: 100px;
        text-align: center;
        ::v-deep .van-button--large {
          width: 100%;
          height: 44px;
          letter-spacing: 1px;
          background: rgba(255, 108, 2, 1);
          border: none;
          border-radius: 0.12rem;
        }
        .btnBg {
          background: rgba(255, 108, 2, 0.3);
        }
      }
    }
  }
}
</style>
